import './assets/main.css'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import 'virtual:svg-icons-register'
import SvgIcon from './components/SvgIcon.vue'
import Toast, { type PluginOptions, POSITION } from 'vue-toastification'
import { register } from 'swiper/element/bundle'
import 'vue-toastification/dist/index.css'
import '@vant/touch-emulator'
import router from './router'
import YouMeng from './utils/YouMeng'

register()
const app = createApp(App)
const options: PluginOptions = {
  hideProgressBar: true,
  timeout: 2500,
  closeButton: false,
  position: POSITION.TOP_CENTER,
}
app.use(Toast, options)
app.use(createPinia())
app.use(router)
app.component('SvgIcon', SvgIcon)
app.mount('#app')
YouMeng.initYoumeng()
YouMeng.initYoumengLog()

const appNode = document.querySelector('#app')
const routerScroll: Record<string, number> = {}
app.provide('routerScroll', routerScroll)
appNode?.addEventListener(
  'scroll',
  useDebounceFn(() => {
    if (router.currentRoute.value.name) {
      routerScroll[router.currentRoute.value.name as string] = appNode.scrollTop
    }
  }, 150),
)
